import { Directive, ViewChild } from '@angular/core';
import { OverviewBaseComponent } from './overview-base.component';
import { Identifiable } from '../../../shared/models/base/identifiable';
import { UnsavedChangesModalComponent } from '../modals/unsaved-changes-modal/unsaved-changes-modal.component';

@Directive()
export abstract class CrudOverviewBaseComponent<T extends Identifiable> extends OverviewBaseComponent<T> {
  @ViewChild('unsavedChangesModal')
  public unsavedChangesModal?: UnsavedChangesModalComponent;
  public selectedItem?: T;

  constructor(key: string) {
    super(key);
  }

  public onClosingSidebar(): void {
    this.selectedTableElement.clearSelection();
    if (
      this.areThereUnsavedChanges<T>(
        this.getFriendlyItemName(this.selectedItem),
        () => this.allowUnsavedChanges(),
        () => this.preventUnsavedChanges(this.selectedItem!)
      ) === false
    ) {
      this.sidebarOpen = false;
      this.selectedItem = undefined;
    }
  }

  public onItemClicked(id: string): void {
    this.selectedTableElement.setSelectedElementId(id, this.paginationService.currentPageNumber);
    if (
      this.areThereUnsavedChanges<T>(
        this.getFriendlyItemName(this.selectedItem),
        () => this.allowUnsavedChanges(),
        () => this.preventUnsavedChanges(this.selectedItem!)
      ) === false
    ) {
      this.handleNewSelection(id);
    }
  }

  public removeItemFromList(id?: string): void {
    if (!this.items || !id) {
      return;
    }

    this.items = this.items.filter((item) => item.id != id);
    this.itemsTotalCount--;
  }

  public startResize(event: MouseEvent): void {
    this.isResizing = true;
    event.preventDefault();
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }

  public allowUnsavedChanges(): void {
    this.selectedItem = undefined;
    if (this.selectedTableElement.isElementSelected) {
      this.handleNewSelection(this.selectedTableElement.selectedElementId!);
    } else {
      this.sidebarOpen = false;
    }
  }

  public preventUnsavedChanges(item: T): void {
    this.configureDetailsView(item);
    this.selectedItem = item;
  }

  protected getItemById(id: string): T | undefined {
    return this.items?.find((item) => item.id === id);
  }

  protected abstract handleNewSelection(id: string): void;
  protected abstract getFriendlyItemName(item?: T): string;
  protected abstract configureDetailsView(item: T): void;
}
